<template>
  <div class="my-Personaldata">
    <div ref="personalTitle" class="titile">{{ $t('个人资料') }}</div>
    <!-- 表单 -->
    <div ref="personalForm" class="form">
      <el-form :model="ruleForm" ref="ruleForm" label-width="80px" class="demo-ruleForm" label-position="left">
        <div class="Avatar" style="align-items: center">
          <div>{{ $t('头像') }}</div>
          <div>
            <el-upload class="avatar-uploader" :action="$BASE_URL + '/api/v1/64803624da6de'" :headers="headers"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img :src="imageUrl" alt="" style="border-radius: 50%;" />
            </el-upload>
          </div>
        </div>

        <el-form-item :label="$t('姓名')">
          <el-input v-model="user_nickname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('手机号')"> {{ user_info.phone }} </el-form-item>
        <el-form-item :label="$t('性别')">
          <el-radio-group v-model="gender">
            <el-radio :label="1">{{ $t('男') }}</el-radio>
            <el-radio :label="2">{{ $t('女') }}</el-radio>
            <el-radio :label="0">{{ $t('保密') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('出生日期')">
          <el-date-picker v-model="birthday" type="date" :placeholder="$t('选择日期')">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('微信')">
          <el-input v-model="wechat"></el-input>
        </el-form-item>

        <el-form-item :label="$t('QQ')">
          <el-input v-model="qq"></el-input>
        </el-form-item>

        <el-form-item :label="$t('邮箱')">
          <el-input v-model="email"></el-input>
        </el-form-item>

        <el-form-item :label="$t('学历')">
          <el-dropdown @command="handleCommand" class="newsOrder" popper-class="personal-data-dropdown">
            <div class="education" :class="{ 'is-selected': academic }">
              <div>{{academic?academic:$t('学历')}}</div>
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="zh_CN" key="zh_CN">中文</el-dropdown-item> -->
              <!-- <el-dropdown-item command="en_US" key="en_US">English</el-dropdown-item> -->
              <el-dropdown-item :command="item" :key="item" :class="{ 'is-selected': academic === item }"
                v-for="(item, index) in academic_list">{{ item }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>

        <el-form-item :label="$t('工作')">
          <el-input v-model="work"></el-input>
        </el-form-item>

        <el-form-item>
          <div class="btn" @click="onAmendMessage">{{ $t('保存') }}</div>
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-button type="primary">主要按钮</el-button> -->
    <!-- <el-button>默认按钮</el-button> -->
  </div>
</template>

<style scoped>
div /deep/ .el-dialog {
  border-radius: 16px;
}
</style>

<script>
import { getToken } from "@/utils/auth";
import { amendMessage, educationBackground } from '@/api/user';
import { userInfo } from '@/api/login';

export default {
  name: "Personaldata",
  data() {
    return {
      ruleForm: {},
      user_info: {},//用户信息
      headers: {},//图片上传的请求头
      user_nickname: '',//姓名
      gender: '',//性别
      birthday: '',//出生日期
      imageUrl: '',//头像
      wechat: '',//微信
      qq: '',//QQ
      academic: '',//学历
      academic_list: [],//学历列表
      work: '',//工作
      email: '',//邮箱
      // 个人资料页面入场动画实例，用于组件销毁时释放动画资源
      personalEntranceAnimation: null,
    };
  },
  created() {

  },
  mounted() {
    this.headers = {
      'user-token': getToken()
    }

    let user_info = JSON.parse(this.$cookies.get('user_info'))
    this.user_info = user_info
    // console.log(user_info);

    this.user_nickname = user_info.user_nickname
    this.gender = user_info.gender
    this.birthday = user_info.birthday
    // console.log(user_info);
    this.imageUrl = user_info.avatar

    this.wechat = user_info.wechat;//微信
    this.qq = user_info.qq;//QQ
    this.academic = user_info.academic;//学历
    this.work = user_info.work;//工作
    this.email = user_info.email;
    // console.log(this.userInfo);
    this.onEducationBackground()
    this.$nextTick(() => {
      this.playPersonalEntranceAnimation();
    });
  },
  beforeDestroy() {
    if (this.personalEntranceAnimation) {
      this.personalEntranceAnimation.progress(1).kill();
    }
  },
  methods: {
    /** 播放个人资料页面的入场动效 */
    playPersonalEntranceAnimation() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      if (this.personalEntranceAnimation) {
        this.personalEntranceAnimation.progress(1).kill();
      }
      const targets = [this.$refs.personalTitle, this.$refs.personalForm].filter(Boolean);
      this.personalEntranceAnimation = this.$gsap.fromTo(targets, {
        y: 16,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.45,
        stagger: 0.1,
        ease: 'power2.out',
        onComplete: () => {
          this.$gsap.set(targets, { clearProps: 'opacity,transform' });
        },
      });
    },
    onEducationBackground() {
      educationBackground().then(res => {
        this.academic_list = res.data;
        // console.log(this.academic_list)
      })
    },
    // 学历切换
    handleCommand(e) {
      // console.log(e);
      this.academic = e
    },
    /**保存修改信息 */
    onAmendMessage() {
      let data = {
        user_nickname: this.user_nickname,
        gender: this.gender,
        birthday: this.birthday,
        email: this.email,
        wechat: this.wechat,
        qq: this.qq,
        academic: this.academic,
        work: this.work
      }
      amendMessage(data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('修改完毕'));
          this.onUserInfo()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**用户信息 */
    onUserInfo() {
      userInfo().then(res => {
        // console.log(res.data);
        if (res.code == 1) {
          this.$cookies.set('user_info', JSON.stringify(res.data), { expires: 7 }); // 7天后过期
          window.location.reload();
        }
      })
    },
    /**成功的回调 */
    handleAvatarSuccess(e) {
      // console.log(e.data.url);
      this.imageUrl = e.data.url;
      let data = {
        avatar: this.imageUrl
      }
      amendMessage(data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('修改完毕'));
          this.onUserInfo()
        } else {
          this.$message.error(res.msg);
        }
      })
      // this.imageUrlLocal = this.$BASE_URL + res.data.url;
    },
    /**判断格式 */
    beforeAvatarUpload(file) {
      const isJPG = file.type == 'image/jpeg' || file.type == 'image/png';

      if (!isJPG) {
        this.$message.error(this.$t('格式错误!'));
      }
      return isJPG;
    },
    handleClose(done) {
      this.$confirm(this.$t('确认关闭？'))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
  },
};
</script>

<style scoped lang="scss">
.my-Personaldata {
  min-width: 1060rpx;
  /* // min-height: 80vh; */
  height: 80vh;
  overflow: auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 24px 0 48px 230px;
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
  margin: 16px 12px 0;

  .titile {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
  }

  .form {
    width: 50%;
    margin-top: 30px;

    .Avatar {
      display: flex;
      margin-bottom: 20px;

      img {
        width: 106px;
        height: 106px;
        margin-left: 40px;
        object-fit: cover;
        object-position: center;
        display: block;
      }
    }

    .btn {
      width: 180px;
      height: 42px;
      background: #000000;
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 42px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      margin-top: 12px;
      cursor: pointer;
    }

    /* 个人资料表单控件选中及聚焦状态统一使用黑色 */
    /deep/ .el-input__inner:focus,
    /deep/ .el-date-editor.el-input.is-active .el-input__inner {
      border-color: #000000;
    }

    /deep/ .el-input.is-active .el-input__inner,
    /deep/ .el-date-editor.is-active {
      border-color: #000000;
    }

    /deep/ .el-input.is-active .el-input__prefix,
    /deep/ .el-input.is-active .el-input__suffix {
      color: #000000;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
      border-color: #000000;
      background: #000000;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #000000;
    }
  }
}

.dialogsure {
  width: 180px;
  height: 40px;
  background: #fd3b00;
  border-radius: 8px 8px 8px 8px;
  text-align: center;
  line-height: 40px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.dialogcancel {
  width: 180px;
  height: 40px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #fd3b00;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #fd3b00;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.upimg {
  width: 220px;
  height: 220px;
  border-radius: 16px 16px 16px 16px;
  background: url("/static/goods.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 80px;
  position: relative;

  .btntext {
    height: 36px;
    background: rgba(51, 51, 51, 0.5);
    border-radius: 0px 0px 16px 16px;
    position: absolute;
    width: 100%;
    bottom: 0;
    text-align: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
    cursor: pointer;
  }
}

.education {
  width: 302px;
  height: 38px;
  border: 1px solid #DCDFE6;
  padding: 0 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.is-selected,
  &:hover {
    border-color: #000000;
  }
}

@media (max-width: 767px) {
  .my-Personaldata {
    margin: 0;
    padding: 16px 12px 24px;
    box-sizing: border-box;

    .form {
      width: 100%;
    }
  }

  .education {
    width: 100%;
  }

  .my-Personaldata .form .btn {
    width: 100%;
  }
}
</style>

<style lang="scss">
 /* 学历下拉菜单挂载在页面外，需要使用全局样式覆盖选中状态 */
.personal-data-dropdown .el-dropdown-menu__item.is-selected,
.personal-data-dropdown .el-dropdown-menu__item:hover,
.personal-data-dropdown .el-dropdown-menu__item:focus {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/view/my/components/Personaldata.vue